import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=6c50ea9f&scoped=true"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"
import style0 from "./Rank.vue?vue&type=style&index=0&id=6c50ea9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50ea9f",
  null
  
)

export default component.exports